import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'dva';
import styles from './index.less';
import { getUrlParam } from 'utils/getValue';
import { Toast } from 'antd-mobile';
import expire from 'images/expire.png'; // 已过期
import invalid from 'images/invalid.png'; // 已失效
import imgUse from 'images/imgUse.png'; // 已使用

import Loading from 'components/Loading';

let timer = null;

function Meal() {
  const dispatch = useDispatch();
  const [isReady, setIsReady] = useState(false); // 是否准备完毕

  const data = useSelector((state) => state.meal);
  const { detail = {}, qrCode, brCode, errMsg } = data;

  useEffect(() => {
    Toast.hide();
    const ciphertext = getUrlParam('ciphertext') || '';
    const sign = getUrlParam('sign') || '';

    if (ciphertext && sign) {
      dispatch({
        type: 'meal/getToken',
        payload: { ciphertext, sign },
        callback: () => {
          getDetail();
        },
      });
    } else {
      getDetail();
    }

    return () => {
      clearTimer();
    };
  }, []);

  useEffect(() => {
    if (errMsg) {
      Toast.fail(errMsg, 0);
      clearTimer();
    }
    return () => {
      clearTimer();
    };
  }, [errMsg]);

  const getDetail = () => {
    dispatch({
      type: 'meal/getMealDetail',
      callback: (res) => {
        setIsReady(true);
        // 60秒刷新一次二维码
        if (res.status === 1 && res.useStatus === 0) {
          timer = setInterval(() => {
            dispatch({
              type: 'meal/getQrcode',
            });
          }, 60000);
        }
      },
    });
  };

  const clearTimer = () => {
    clearInterval(timer);
    window.clearInterval(timer);
    timer = null;
  };

  const {
    agentName,
    money,
    moneyCode,
    validDateTo,
    availableCount,
    currency,
    currencyConvertAmount,
    status, //     "status":1, // 状态（0失效，1生效）,
    useStatus, // 0 未使用 1已使用
  } = detail;

  const canUse = status === 1 && useStatus === 0; // 判断是否正常使用
  let statusImg = expire;
  if (status === 0) {
    statusImg = invalid;
  }
  if (useStatus === 1) {
    statusImg = imgUse;
  }
  return (
    <Loading loading={!isReady}>
      <div className={styles.pageMealDetal} style={{ opacity: errMsg ? 0 : 1 }}>
        <div className={styles.content}>
          <div className={styles.lngTitle}>
            <span className={styles.zn}>龙腾出行·饭票</span>
            <span className={styles.en}>DragonPass Meal Ticket</span>
          </div>
          <div className={styles.coreBox}>
            <span className={styles.coreNo}>{moneyCode}</span>
            <img className={styles.brcodeImg} src={brCode} alt="" />
            <img className={styles.qrcodeImg} src={qrCode} alt="" />
            {!canUse && <img className={styles.expireImg} src={statusImg} alt="" />}
          </div>
          <div className={styles.lineBox}>
            <div className={styles.l}></div>
            <div className={styles.line}></div>
            <div className={styles.r}></div>
          </div>
          {/* 饭票信息 */}
          <div className={styles.cellBox}>
            <div className={styles.cellLeft}>
              <span className={styles.label}>面额</span>
              <span className={styles.label}>Face Value</span>
            </div>
            <div className={styles.cellRight}>￥{money}</div>
          </div>
          {/* 汇率 */}
          <div className={styles.cellBox}>
            <div className={styles.cellLeft}>当前汇率: {currency}</div>
            <div className={styles.cellRight}>US${currencyConvertAmount}</div>
          </div>
          {/* 有校日期 */}
          <div className={styles.cellBox}>
            <div className={styles.cellLeft}>
              <span className={styles.label}>有效日期至</span>
              <span className={styles.label}>Validity</span>
            </div>
            <div className={styles.cellRight}>{validDateTo}</div>
          </div>
          {/* 发券机构 */}
          <div className={styles.cellBox}>
            <div className={styles.cellLeft}>
              <span className={styles.label}>发券机构</span>
              <span className={styles.label}>Issuer</span>
            </div>
            <div className={styles.cellRight}>{agentName}</div>
          </div>

          <div
            className={styles.btnBox}
            onClick={() => {
              window.location.href = detail.availableNetworkUrl;
            }}
          >
            查看适用网点 ({availableCount}家)
          </div>
          {/* 使用须知 */}
          <div className={styles.useBox}>
            <span className={styles.tip}>使用须知</span>
            <span className={`${styles.tip} ${styles.aKey}`}>本现金券不兑换，不找零</span>
            <span className={styles.tip}>Cash Coupon cannot be redeemed for cash or refund.</span>
          </div>
        </div>
      </div>
    </Loading>
  );
}

export default Meal;
